import { FormErrorText } from '@exam-management/components';
import {
  CloseRoundedIcon,
  Divider,
  Flex,
  FormNumberInput,
  IconButton,
  Text,
} from '@shared/components';

import {
  ItemSetQuestionPropertiesTable,
  type ItemSetQuestionPropertiesTableProps,
} from '../item-set-question-properties-table';

export interface ItemSetQuestionPropertiesSectionProps extends ItemSetQuestionPropertiesTableProps {
  onClose?: () => void;
  errorMessage?: string;
}

export default function ItemSetQuestionPropertiesSection(
  props: Readonly<ItemSetQuestionPropertiesSectionProps>,
) {
  const { prefixName, onClose, errorMessage, ...restProps } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        bgcolor: theme.palette.background.paper,
        borderRadius: theme.shape.rounded(2),
        border: '1px solid',
        borderColor: theme.palette.divider,
      })}
    >
      <Flex
        sx={(theme) => ({
          p: theme.spacing(3, 4),
        })}
      >
        <Text variant='body1Semibold' sx={{ flex: 1 }}>
          Question Properties
        </Text>
        {onClose ? (
          <IconButton sx={{ p: 0 }} onClick={onClose}>
            <CloseRoundedIcon />
          </IconButton>
        ) : null}
      </Flex>
      <Divider />
      <Flex
        sx={(theme) => ({
          p: theme.spacing(4),
          gap: theme.spacing(4),
          flexDirection: 'column',
        })}
      >
        <FormNumberInput
          name={`${prefixName}.needTotal`}
          label='จำนวน Set'
          placeholder='ระบุจำนวน Set'
          sx={{
            maxWidth: '180px',
          }}
        />
        <ItemSetQuestionPropertiesTable prefixName={`${prefixName}.properties`} {...restProps} />
        {errorMessage ? <FormErrorText>{errorMessage}</FormErrorText> : null}
      </Flex>
    </Flex>
  );
}
